import { getBedrockCapabilities } from './model-capabilities';
import { getModelById, isModelAlias, resolveLegacyBedrockModelId } from './model-registry';
import { REASONING_LEVEL_LABELS } from './reasoning-levels';
/**
 * 応答に記録されたモデル ID の表示名を返す（チャット画面・管理画面で共有）。
 *
 * 正式なモデル ID（旧 Bedrock ID の読み替えを含む）はレジストリの表示名にする。
 * エイリアスや未知の値は記録値をそのまま返す。エイリアスを現在のモデルへ読み替えると、
 * 向き先が変わった後に過去の応答まで新しいモデル名で表示されてしまうため。
 */
export function getModelDisplayName(modelId, provider) {
    if (provider !== 'bedrock' || isModelAlias(modelId)) {
        return modelId;
    }
    const definition = getModelById(modelId, 'bedrock') ??
        getModelById(resolveLegacyBedrockModelId(modelId), 'bedrock');
    return definition?.displayName ?? modelId;
}
/**
 * 応答に記録されたエフォートの表示名を返す。
 * エフォートを指定できないモデルや記録がない場合は undefined（表示しない）。エイリアスや未知のモデルでは記録された段階の名称をそのまま示す。
 */
export function getReasoningLevelDisplayLabel(modelId, level) {
    if (!level)
        return undefined;
    if (!isModelAlias(modelId) && getModelById(modelId, 'bedrock')) {
        const { reasoning } = getBedrockCapabilities(modelId);
        if (reasoning.kind === 'none')
            return undefined;
    }
    return REASONING_LEVEL_LABELS[level];
}
//# sourceMappingURL=model-display.js.map